module.exports = __webpack_public_path__ + "img/receiver-open-icon.a40e9a84.png";